/* ---------- Apple Watch size guide popup ----------
   "Not sure of your size?" on the Apple Watch Size label
   (snippets/lla-size-guide.liquid). The dialog and its image are built on
   the first tap, so nothing loads for shoppers who never open it. Closes on
   the button, Esc or a tap outside the image. */
(function () {
  var dlg = null;
  function build(src) {
    dlg = document.createElement('dialog');
    dlg.className = 'lla-sizeguide';
    dlg.setAttribute('aria-label', 'How to find your Apple Watch size');
    dlg.innerHTML =
      '<button type="button" class="lla-sizeguide__close" aria-label="Close">&times;</button>' +
      '<img class="lla-sizeguide__img" alt="How to find your Apple Watch size">';
    dlg.querySelector('img').src = src;
    dlg.querySelector('.lla-sizeguide__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    document.body.appendChild(dlg);
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-lla-size-guide]');
    if (!link) return;
    e.preventDefault();
    if (!dlg) build(link.getAttribute('data-lla-size-guide'));
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else window.open(link.getAttribute('data-lla-size-guide'), '_blank', 'noopener');
  });
})();

/* Luxe Life Accessories — cart drawer behaviour
   Lean + event-driven. NO work on plain page loads (perf): the drawer is
   server-rendered with correct state; JS only acts on cart events / drawer open.

   PRICE INTEGRITY: this file only inserts/removes the gift LINE. The zero price
   MUST be enforced server-side by a Shopify automatic discount or Function.
   autoAdd is therefore off until a gift product is selected in Theme settings
   AND that discount is confirmed live in every market — otherwise the customer
   is charged full price for a "gift".

   The gift product and variant are read from window.LLA_CART, which Liquid
   builds from Theme settings. No product handle or variant id is hard-coded
   here, so changing the campaign's gift is a Customize change, not a code
   change. */
(function () {
  var CFG = window.LLA_CART || {};
  var GIFT_HANDLE = CFG.giftHandle || '';
  var GIFT_ALT_HANDLE = CFG.giftAltHandle || '';
  var GIFT_VARIANT = CFG.giftVariantId || 0;
  var GIFT_NAME = CFG.giftName || '';
  /* Second gift slot: the Apple Watch cover. Independent of the bracelet —
     an Apple Watch order earns both, so this is a separate slot rather than a
     third choice within the bracelet slot. */
  var CASE_HANDLE = CFG.caseHandle || '';
  var CASE_ALT_HANDLE = CFG.caseAltHandle || '';
  var CASE_VARIANT = CFG.caseVariantId || 0;
  var CASE_KEYWORDS = String(CFG.caseTriggerKeywords || '')
    .toLowerCase().split(',').map(function (k) { return k.trim(); }).filter(Boolean);
  var SHIP_LIMIT = parseInt(CFG.shipLimit, 10) || 0;
  var PAIRS_COLL = CFG.pairsCollection || '';
  var inFlight = false, debounce = null, moTimer = null, pairsSeed = null, syncing = false;

  /* Prices written by this file go through the same wrapper every other
     JS-rendered price uses, so the cart matches the rest of the storefront
     (amount + ISO code) and stays correct per market. */
  function formatMoney(cents) {
    var currency = window.themeVendor && window.themeVendor.themeCurrency;
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    if (currency && typeof currency.formatMoney === 'function') {
      return currency.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  /* ---------- helpers ---------- */
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  /* The free third piece from Buy 2, Get 1 Free is ALSO a zero-priced line, but
     it is a paid-for piece of the offer, not a gift — it must keep counting
     towards the 3-for-2 progress. Recognised by the discount's title. */
  var B2G1_RE = /buy ?2|get ?1|b2g1|3.?for.?2|third/i;
  function is3for2(it) {
    var d = (it.discounts || []).concat((it.line_level_discount_allocations || []).map(function (a) {
      return (a.discount_application || {});
    }));
    return d.some(function (x) { return B2G1_RE.test(x.title || ''); });
  }
  /* A line counts as the gift if it IS the configured gift product, or if it
     carries the gift property, or if it is a zero-priced line that is not the
     Buy 2, Get 1 Free reward (i.e. a gift-with-purchase). */
  function isGift(it) {
    if (GIFT_HANDLE && it.handle === GIFT_HANDLE) return true;
    if (GIFT_ALT_HANDLE && it.handle === GIFT_ALT_HANDLE) return true;
    if (CASE_HANDLE && it.handle === CASE_HANDLE) return true;
    if (CASE_ALT_HANDLE && it.handle === CASE_ALT_HANDLE) return true;
    if (it.properties && (it.properties._lla_gift || it.properties._lla_case)) return true;
    if (it.final_line_price === 0 && !is3for2(it)) return true;
    return false;
  }
  function paidCount(cart) { return cart.items.reduce(function (n, it) { return n + (isGift(it) ? 0 : it.quantity); }, 0); }

  /* Each slot is matched on its own, because a cart can legitimately hold both
     gifts at once. Matching on "the first free line" — which is all the cart
     used to do — would make the cover look like the bracelet was already there
     and stop the bracelet ever being added. */
  function braceletLinesIn(cart) {
    return cart.items.filter(function (it) {
      if (GIFT_HANDLE && it.handle === GIFT_HANDLE) return true;
      if (GIFT_ALT_HANDLE && it.handle === GIFT_ALT_HANDLE) return true;
      return !!(it.properties && it.properties._lla_gift);
    });
  }
  function caseLinesIn(cart) {
    return cart.items.filter(function (it) {
      if (CASE_HANDLE && it.handle === CASE_HANDLE) return true;
      if (CASE_ALT_HANDLE && it.handle === CASE_ALT_HANDLE) return true;
      return !!(it.properties && it.properties._lla_case);
    });
  }
  function braceletLineIn(cart) { return braceletLinesIn(cart)[0]; }
  function caseLineIn(cart) { return caseLinesIn(cart)[0]; }
  function giftLineIn(cart) {
    return braceletLineIn(cart) || cart.items.filter(isGift)[0];
  }

  /* Does this cart earn the free cover?

     The product page stamps _lla_aw when it adds an Apple Watch line, which is
     the reliable signal: Liquid can see the product's type AND its collections
     there. Quick-add tiles and third-party add-to-cart calls do not go through
     that form, so the line's own product type, title and handle are checked as
     a fallback. */
  function isAppleWatchLine(it) {
    if (isGift(it)) return false;
    if (it.properties && it.properties._lla_aw) return true;
    if (!CASE_KEYWORDS.length) return false;
    var hay = [it.product_type, it.product_title, it.title, it.handle]
      .filter(Boolean).join(' ').toLowerCase();
    return CASE_KEYWORDS.some(function (k) { return hay.indexOf(k) !== -1; });
  }
  function appleWatchCount(cart) {
    return cart.items.reduce(function (n, it) { return n + (isAppleWatchLine(it) ? it.quantity : 0); }, 0);
  }

  /* ---------- free-shipping progress ----------
     Owned entirely by this file. The qualifying total deliberately EXCLUDES
     gift lines, so a gift can never push a customer over the threshold — and
     it is recomputed from /cart.js on every cart event rather than trusting a
     number rendered into the page, which goes stale the moment a quantity
     changes. */
  function qualifyingTotal(cart) {
    var lines = cart.items.reduce(function (sum, it) {
      return sum + (isGift(it) ? 0 : it.final_line_price);
    }, 0);
    /* Order-level discounts (e.g. a sitewide code) come off as well: Shopify tests
       price-based shipping rates against the discounted subtotal. */
    var orderDiscount = (cart.cart_level_discount_applications || []).reduce(function (sum, d) {
      return sum + (d.total_allocated_amount || 0);
    }, 0);
    return Math.max(0, lines - orderDiscount);
  }

  /* ---------- free-shipping threshold in the shopper's currency ----------
     snippets/lla-freeship.liquid marks every threshold with either
       data-lla-fs-cents  exact local figure (GBP, or a currency with an
                          override such as USD:100) — used as-is
       data-lla-fs-base   GBP base only, for a currency with no override —
                          converted here with Shopify.currency.rate, the rate
                          Markets uses to convert the shipping-rate condition,
                          and rounded UP to a whole unit so the storefront
                          never promises less than checkout requires. */
  function shopRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  /* Exact conversion, to the cent — used for the progress-bar maths so the
     bar flips to "unlocked" at the same point checkout does. */
  function convertBase(baseCents) {
    return Math.round(baseCents * shopRate());
  }
  /* Rounded UP to a whole unit — used only for figures shown in copy
     ("Free shipping over 113 CAD"), so the headline never promises less. */
  function convertBaseDisplay(baseCents) {
    return Math.ceil(convertBase(baseCents) / 100) * 100;
  }
  function localLimitCents(el) {
    var exact = parseInt(el.getAttribute('data-lla-fs-cents'), 10);
    if (exact > 0) return exact;
    var base = parseInt(el.getAttribute('data-lla-fs-base'), 10);
    if (base > 0) return convertBase(base);
    return parseInt(el.getAttribute('data-lla-ship-limit'), 10) || SHIP_LIMIT;
  }

  /* Plain threshold figures in copy ("Worldwide on orders over 80 GBP"). */
  function convertStaticFigures() {
    document.querySelectorAll('span[data-lla-fs-base]').forEach(function (el) {
      if (el.getAttribute('data-lla-fs-done')) return;
      var base = parseInt(el.getAttribute('data-lla-fs-base'), 10);
      if (!base) return;
      el.textContent = formatMoney(convertBaseDisplay(base));
      el.setAttribute('data-lla-fs-done', '1');
    });
  }

  function updateShipBar(cart) {
    var bars = document.querySelectorAll('[data-lla-ship]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var limit = localLimitCents(bar);
      if (!limit) return;

      var total = qualifyingTotal(cart);
      var remaining = limit - total;
      var percent = Math.max(0, Math.min(100, Math.round((total / limit) * 100)));

      var fill = bar.querySelector('[data-lla-ship-fill]');
      if (fill) fill.style.width = percent + '%';

      var track = bar.querySelector('.lla-ship__track');
      if (track) track.setAttribute('aria-valuenow', percent);

      var text = bar.querySelector('[data-lla-ship-text]');
      if (text) {
        if (remaining <= 0) {
          text.innerHTML = '<strong>FREE SHIPPING UNLOCKED</strong>';
        } else {
          text.innerHTML = 'You’re <strong>' + formatMoney(remaining) +
            '</strong> away from free shipping';
        }
      }
      bar.classList.toggle('is-unlocked', remaining <= 0);
      bar.classList.remove('is-converting');
    });
  }

  /* The theme's own bars (cart page, announcement bar) are recalculated by
     theme.js as data-limit x currency rate, which double-converts a market
     that has its own merchandised figure. They are corrected here from the
     same local limit the drawer uses. */
  function fixThemeBars(cart) {
    document.querySelectorAll('[data-lla-theme-ship]').forEach(function (msg) {
      var limit = localLimitCents(msg);
      if (!limit) return;
      var total = qualifyingTotal(cart);
      var remaining = limit - total;
      var percent = Math.max(0, Math.min(100, Math.round((total / limit) * 100)));
      msg.querySelectorAll('[data-left-to-spend]').forEach(function (el) {
        el.textContent = formatMoney(Math.max(0, remaining));
      });
      msg.querySelectorAll('[data-cart-message-progress]').forEach(function (el) {
        el.value = percent;
        el.style.setProperty('--progress-width', percent + '%');
      });
      var hasSuccess = msg.getAttribute('data-cart-message') === 'true';
      var def = msg.querySelector('[data-message-default]');
      msg.classList.toggle('is-success', hasSuccess && remaining <= 0 && total > 0);
      msg.classList.toggle('is-hidden', total === 0 || (!hasSuccess && remaining <= 0));
      if (def) def.classList.toggle('is-hidden', hasSuccess && remaining <= 0);
    });
  }
  function refreshTheme() {
    // Trigger the theme's own drawer re-render (dispatched events alone don't redraw it)
    if (window.cart && typeof window.cart.getCart === 'function') { try { window.cart.getCart(); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  /* ---------- Buy 2, Get 1 Free progress header + countdown ----------
     The 3-for-2 header (snippets/lla-cart-header.liquid) is server-rendered
     with the right state; this keeps it in step live as lines change. Eligible
     = paid pieces plus the free third piece; gifts (the Apple Watch cover) are
     excluded. */

  function eligibleCount(cart) { return cart.items.reduce(function (n, it) { return n + (isGift(it) ? 0 : it.quantity); }, 0); }
  /* Total taken off by the Buy 2, Get 1 Free discount, in cents. */
  function b2g1Saving(cart) {
    return cart.items.reduce(function (sum, it) {
      var allocs = it.line_level_discount_allocations || [];
      if (allocs.length) {
        return sum + allocs.reduce(function (s, a) {
          var t = (a.discount_application && a.discount_application.title) || '';
          return s + (B2G1_RE.test(t) ? (a.amount || 0) : 0);
        }, 0);
      }
      return sum + (it.discounts || []).reduce(function (s, d) {
        return s + (B2G1_RE.test(d.title || '') ? (d.amount || 0) : 0);
      }, 0);
    }, 0);
  }
  /* Copy per state — keep in step with snippets/lla-cart-header.liquid. */
  function stateFor(elig, saving) {
    var st = {
      b: Math.min(elig, 3) + ' in the 3 for 2',
      t: saving > 0 ? "You're saving " + formatMoney(saving) : ''
    };
    if (elig >= 3) { st.s = 'unlocked'; st.sub = 'Your lowest priced item is free! We hope you love it.'; }
    else if (elig === 2) { st.s = 'close'; st.sub = 'Add 1 more and the lowest-priced of the three is free.'; }
    else if (elig === 1) { st.s = 'start'; st.sub = 'Add 2 more and the lowest-priced of the three is free.'; }
    else { st.s = 'start'; st.sub = 'Add 3 and the lowest-priced of the three is free.'; }
    return st;
  }

  /* The cover's value ("£15") in currencies without a fixed figure — see
     snippets/lla-aw-worth.liquid. Rounded UP to a whole unit. */
  function convertWorth() {
    var r = shopRate();
    document.querySelectorAll('[data-lla-worth-base]').forEach(function (el) {
      var base = parseInt(el.getAttribute('data-lla-worth-base'), 10);
      if (!base || r === 1) return;
      el.textContent = (el.getAttribute('data-lla-worth-symbol') || '') + Math.ceil(Math.round(base * r) / 100);
      el.removeAttribute('data-lla-worth-base');
    });
  }
  /* Confetti the moment the 3 for 2 unlocks (2 -> 3 pieces). The last count
     is kept per session, so a page load with 3 already in the cart does not
     fire it again. Brand colours; skipped for reduced-motion users. */
  var PREV_KEY = 'lla_3for2_prev';
  function checkUnlock(elig) {
    var prev = null;
    try { prev = sessionStorage.getItem(PREV_KEY); } catch (e) {}
    try { sessionStorage.setItem(PREV_KEY, String(elig)); } catch (e) {}
    if (prev !== null && parseInt(prev, 10) < 3 && elig >= 3) confetti();
  }
  function confetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
    document.body.appendChild(cv);
    var dpr = window.devicePixelRatio || 1, W = window.innerWidth, H = window.innerHeight;
    cv.width = W * dpr; cv.height = H * dpr;
    var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
    var origin = { x: W / 2, y: H * 0.25 };
    var panel = document.querySelector('[data-lla-cart-promo]');
    if (panel) {
      var r = panel.getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < H) origin = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    var colours = ['#410016', '#FBF8F2', '#E8B4A0', '#F3E3C3', '#8A2B45'];
    var parts = [];
    for (var i = 0; i < 140; i++) {
      var a = Math.random() * Math.PI * 2, sp = 5 + Math.random() * 8;
      parts.push({
        x: origin.x, y: origin.y,
        vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 6,
        w: 6 + Math.random() * 6, h: 8 + Math.random() * 8,
        rot: Math.random() * Math.PI, vr: (Math.random() - .5) * .15,
        c: colours[i % colours.length]
      });
    }
    var start = null, DUR = 4000;
    function frame(t) {
      if (!start) start = t;
      var el = t - start;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = el > DUR - 1000 ? Math.max(0, (DUR - el) / 1000) : 1;
      parts.forEach(function (p) {
        p.vy += .12; p.vx *= .985; p.vy *= .99; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.rot * 2)));
        ctx.restore();
      });
      if (el < DUR) requestAnimationFrame(frame); else cv.remove();
    }
    requestAnimationFrame(frame);
  }

  function syncUI(cart) {
    var apply = function (c) {
      syncing = true;
      var elig = eligibleCount(c), st = stateFor(elig, b2g1Saving(c));
      checkUnlock(elig);
      document.querySelectorAll('[data-lla-cart-promo]').forEach(function (p) {
        p.setAttribute('data-lla-eligible', elig);
        p.setAttribute('data-lla-state', st.s);
        var title = p.querySelector('[data-lla-title]'); if (title) { title.textContent = st.t; title.hidden = !st.t; }
        var badge = p.querySelector('[data-lla-badge]'); if (badge) badge.textContent = st.b;
        var sub = p.querySelector('[data-lla-sub]'); if (sub) sub.textContent = st.sub;
        var segs = p.querySelectorAll('.lla-seg');
        for (var i = 0; i < segs.length; i++) segs[i].classList.toggle('is-filled', elig >= i + 1);
        var segFree = p.querySelector('[data-lla-seg-free]'); if (segFree) segFree.textContent = elig >= 3 ? 'Free' : '3rd free';
      });
      var hasCover = caseLinesIn(c).length > 0;
      document.querySelectorAll('[data-lla-aw-pill]').forEach(function (el) { el.hidden = !hasCover; });
      convertWorth();
      updateShipBar(c);
      fixThemeBars(c);
      convertStaticFigures();
      renderPairs(c);
      decoratePairPrices();
      setTimeout(function () { syncing = false; }, 60);
    };
    if (cart) apply(cart); else getCart().then(apply);
  }

  /* ---------- one free gift per cart ----------
     A link-gated gift offer (the free case builder) writes attributes._offer to
     the cart and stamps _offer on its gift line. While either is present the
     campaign gift must not auto-add, and a campaign gift already in the cart is
     removed — the link-gated gift wins. This is the client-side half of mutual exclusivity;
     it generalises to any future campaign without further theme work. */
  function giftOfferActive(cart) {
    /* Only a real link-gated gift LINE counts. The cart attribute alone used to
       be enough, but that attribute survives after its line is removed, so a
       single old bundle-builder session could suppress the campaign gift
       permanently with nothing on screen to explain why. A line is
       self-clearing; an attribute is not. */
    return cart.items.some(function (it) { return it.properties && it.properties._offer; });
  }

  /* A link-gated gift is only free while its discount applies. Shopify decides
     that server-side on every recalculation, so the line's own price is the
     honest test: if the band was removed, or the code expired or hit its cap,
     the line is being charged and must come back out. Cheaper and more truthful
     than re-deriving collection eligibility in the browser. */
  function staleGiftLine(cart) {
    if (!CFG.giftPriceCheck) return null;
    return cart.items.filter(function (it) {
      return it.properties && it.properties._offer && it.final_line_price > 0;
    })[0];
  }

  function setLineQuantity(key, quantity) {
    inFlight = true;
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(function () { inFlight = false; refreshTheme(); })
      .catch(function () { inFlight = false; });
  }
  function removeLine(key) { return setLineQuantity(key, 0); }

  /* ---------- one of each gift, quantity one ----------
     Hiding the quantity picker is presentation, not a rule. A cart saved before
     this shipped, a second add from the gift product's own page, a browser that
     has not applied the stylesheet, or any request made outside the drawer can
     all leave a gift line sitting at two or more. This is the check that
     actually holds, and it runs on every cart event before anything else.

     One correction per pass, because writing to the cart fires a cart event
     that brings us straight back with fresh state — two writes from one stale
     snapshot is how lines get double-counted. Returns true when it acted, so
     the caller stops and waits for the next pass. */
  var clampAttempts = 0;
  function enforceGiftLimits(cart) {
    if (clampAttempts > 8) return false;
    var slots = [braceletLinesIn(cart), caseLinesIn(cart)];
    for (var i = 0; i < slots.length; i++) {
      var lines = slots[i];
      if (!lines.length) continue;

      /* A duplicate LINE of the same gift — two colourways of the bracelet, say,
         after a swap that half-completed. The newest one goes; the customer
         keeps the gift they have. */
      if (lines.length > 1) {
        clampAttempts++;
        removeLine(lines[lines.length - 1].key);
        return true;
      }
      if (lines[0].quantity > 1) {
        clampAttempts++;
        setLineQuantity(lines[0].key, 1);
        return true;
      }
    }
    return false;
  }

  /* ---------- auto add / remove the complimentary gift ----------
     Adds the configured gift once the cart holds at least one paid item, and
     takes it back out when the last paid item leaves so a lone free line is
     never checked out on its own. Does nothing at all unless a gift product
     and variant are configured AND auto-add is switched on. */
  /* Liquid can only see products published to the Online Store channel, so
     all_products[handle] comes back empty for a hidden gift and the id arrives
     as 0. Asking the storefront for the product directly covers that case, and
     says plainly in the console when it cannot. Resolved once, then cached. */
  var variantLookup = {};
  function variantForHandle(handle, known) {
    if (known) return Promise.resolve(known);
    if (!handle) return Promise.resolve(0);
    if (variantLookup[handle]) return variantLookup[handle];
    variantLookup[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var v = p && (p.variants || []).filter(function (x) { return x.available; })[0];
        if (v) return v.id;
        console.warn('[LLA] Complimentary gift not added: product "' + handle +
          '" could not be found, is not published to the Online Store sales channel, ' +
          'or has no variant in stock.');
        return 0;
      })
      .catch(function () { return 0; });
    return variantLookup[handle];
  }
  function ensureGiftVariant() {
    return variantForHandle(GIFT_HANDLE, GIFT_VARIANT).then(function (id) {
      if (id) GIFT_VARIANT = id;
      return id;
    });
  }
  function ensureCaseVariant() {
    return variantForHandle(CASE_HANDLE, CASE_VARIANT).then(function (id) {
      if (id) CASE_VARIANT = id;
      return id;
    });
  }

  /* A failed add must not become a loop. refreshTheme() fires a cart event,
     which calls reconcile() again, so a gift that Shopify silently refuses
     (out of stock, not available in this market) would otherwise be retried for
     as long as the page is open. Three attempts is enough to survive a dropped
     request and few enough to stay invisible. */
  var addAttempts = {};
  function mayAttempt(slot) {
    addAttempts[slot] = (addAttempts[slot] || 0) + 1;
    return addAttempts[slot] <= 3;
  }

  function addGiftLine(slot, variantId, properties) {
    if (!variantId) { return Promise.resolve(false); }
    if (!mayAttempt(slot)) { return Promise.resolve(false); }
    inFlight = true;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
    })
      .then(function (r) {
        inFlight = false;
        if (!r.ok) {
          console.warn('[LLA] Complimentary gift could not be added to the cart. ' +
            'Check the gift product is in stock and available in this market.');
          return false;
        }
        refreshTheme();
        return true;
      })
      .catch(function () { inFlight = false; return false; });
  }

  /* One change per pass. Adding or removing a line fires a cart event, which
     brings reconcile straight back with fresh state, so doing two writes from
     one stale snapshot of the cart is how lines end up duplicated. */
  function reconcile() {
    if (inFlight) return;
    if (CFG.autoAdd) ensureGiftVariant();
    getCart().then(function (cart) {
      var stale = staleGiftLine(cart);
      if (stale) { removeLine(stale.key); return; }

      if (enforceGiftLimits(cart)) return;

      var braceletLine = braceletLineIn(cart);
      if (giftOfferActive(cart)) {
        if (braceletLine) { removeLine(braceletLine.key); } else { syncUI(cart); }
        return;
      }

      var hasPaidItem = paidCount(cart) > 0;
      if (CFG.autoAdd) {
        if (hasPaidItem && !braceletLine) {
          ensureGiftVariant().then(function (variantId) {
            if (!variantId) { syncUI(cart); return; }
            addGiftLine('bracelet', variantId, { _lla_gift: GIFT_HANDLE });
          });
          return;
        }
        if (!hasPaidItem && braceletLine) { removeLine(braceletLine.key); return; }
      } else if (braceletLine) {
        /* The bracelet offer is retired: one left over in a cart from before
           the switch comes back out, so it is never checked out. The cover
           logic below carries on regardless. */
        removeLine(braceletLine.key); return;
      }

      /* The cover is earned by the Apple Watch range only, so it comes back out
         again the moment the last Apple Watch line leaves the cart. */
      var caseLine = caseLineIn(cart);
      var earnsCase = appleWatchCount(cart) > 0;
      if (earnsCase && !caseLine) {
        ensureCaseVariant().then(function (variantId) {
          if (!variantId || CFG.caseAutoAdd === false) { syncUI(cart); return; }
          addGiftLine('case', variantId, { _lla_case: 'main' });
        });
        return;
      }
      if (!earnsCase && caseLine) { removeLine(caseLine.key); return; }

      syncUI(cart);
    }).catch(function () { inFlight = false; });
  }

  /* The gold/silver swatch switcher that used to live here belonged to the
     retired Forever Hoops gift and depended on two hard-coded variant ids. The
     current gift is a single configured variant, so there is nothing to swap;
     if a future gift needs variant choice, it should read its options from
     window.LLA_CART rather than reintroducing literal ids. */

  /* ---------- "You'll love this too" — cart upsell ----------------------------

     Recommendation priority, highest first:

       1  what the shopper has been BROWSING     (recently-viewed cookie)
       2  what is in the CART right now
       3  Shopify's complementary recommendations for either seed
       4  a fallback collection

     Browsing is ranked above the cart because it is the better signal of
     intent: the cart says what they already decided on, the browse history
     says what they are still deciding about. Both go through Shopify's own
     recommendations endpoint, so the actual product relationships come from
     Shopify rather than from a hand-written map that would rot.

     The theme already records recently-viewed product HANDLES in the
     shopify_recently_viewed cookie for its "Recently viewed" section, so this
     reuses that rather than starting a second store of the same data. */

  var SEEN_COOKIE = 'shopify_recently_viewed';

  function recentlyViewedHandles() {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + SEEN_COOKIE + '=([^;]*)'));
      if (!m) return [];
      return decodeURIComponent(m[1]).split(' ').filter(Boolean);
    } catch (e) { return []; }
  }

  /* Two endpoints feed this row and they do NOT agree on shape.
     /recommendations/products.json and /products/<handle>.js return price in
     CENTS as a number and images as plain URL strings; /collections/<handle>/
     products.json has no top-level price at all and returns image OBJECTS.
     Reading only the first shape produced NaN prices and [object Object] image
     sources whenever the fallback collection was the source. */
  function priceCents(p) {
    if (typeof p.price === 'number') return p.price;
    var v = (p.variants || [])[0];
    var raw = p.price != null ? p.price : (v && v.price);
    if (typeof raw === 'number') return raw;
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function productImage(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    return typeof img === 'string' ? img : '';
  }

  function productUrl(p) { return p.url || ('/products/' + p.handle); }

  /* ---------- card colour swatches ----------------------------------------
     Small swatches under each "You'll love this too" card, one per colour.
     Colours come from the theme's own swatch list (assets/swatches.json,
     matched exactly the way the theme matches its product-page swatches:
     lower-case, spaces ignored), so the cart and the product pages agree.
     A colour the list doesn't know falls back to a tiny photo of that
     variant. Picking a swatch swaps the card's photo, price and the variant
     that Add uses — and the band size-matching then keeps that colour. */
  var COLOR_OPTION = /^(colou?r|metal colou?r)$/i;
  var swatchMap = null;
  function loadSwatchMap() {
    if (swatchMap) return swatchMap;
    var url = window.theme && window.theme.assets && window.theme.assets.swatches;
    swatchMap = (url ? fetch(url).then(function (r) { return r.ok ? r.json() : null; }) : Promise.resolve(null))
      .then(function (d) {
        var map = {};
        ((d && d.colors) || []).forEach(function (o) {
          Object.keys(o).forEach(function (k) { map[k.toLowerCase().replace(/\s/g, '')] = o[k]; });
        });
        return map;
      })
      .catch(function () { return {}; });
    return swatchMap;
  }
  function colorIndex(p) {
    var names = (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).trim(); });
    for (var i = 0; i < names.length; i++) if (COLOR_OPTION.test(names[i])) return i;
    return -1;
  }
  function variantCents(v) {
    if (typeof v.price === 'number') return v.price;
    var n = parseFloat(v.price); return isNaN(n) ? 0 : Math.round(n * 100);
  }
  function variantImage(v, p) {
    var img = v && v.featured_image;
    if (img && typeof img === 'object') img = img.src;
    return (typeof img === 'string' && img) ? img : productImage(p);
  }
  function esc(str) { var d = document.createElement('div'); d.textContent = String(str == null ? '' : str); return d.innerHTML; }

  /* One entry per colour that has at least one variant in stock, in the
     product's own order, each pointing at its first available variant. */
  function colourChoices(p) {
    var ci = colorIndex(p);
    if (ci === -1) return [];
    var seen = {}, out = [];
    (p.variants || []).forEach(function (v) {
      if (!v.available) return;
      var name = variantOptions(v)[ci];
      if (name == null || seen[name]) return;
      seen[name] = 1;
      out.push({ name: name, variant: v });
    });
    return out;
  }

  var MAX_SWATCHES = 4;
  function swatchesHtml(p, lead) {
    var choices = colourChoices(p);
    if (choices.length < 2) return '';
    var ci = colorIndex(p);
    var current = variantOptions(lead)[ci];
    var shown = choices.slice(0, MAX_SWATCHES);
    return '<div class="lla-pair-card__swatches" role="group" aria-label="Colour">' +
      shown.map(function (c) {
        var on = c.name === current;
        return '<button type="button" class="lla-pair-swatch' + (on ? ' is-active' : '') + '"' +
          ' data-lla-swatch="' + esc(c.name) + '" data-lla-swatch-variant="' + c.variant.id + '"' +
          ' aria-label="' + esc(c.name) + '" aria-pressed="' + on + '" title="' + esc(c.name) + '"></button>';
      }).join('') +
      (choices.length > MAX_SWATCHES
        ? '<a class="lla-pair-swatch-more" href="' + productUrl(p) + '">+' + (choices.length - MAX_SWATCHES) + '</a>' : '') +
      '</div>';
  }

  /* Colour the swatch buttons once the theme's swatch list has loaded. */
  function paintSwatches(root) {
    var btns = (root || document).querySelectorAll('[data-lla-swatch]:not([data-lla-painted])');
    if (!btns.length) return;
    loadSwatchMap().then(function (map) {
      var base = (window.theme && window.theme.assets && window.theme.assets.base) || '/';
      btns.forEach(function (b) {
        b.setAttribute('data-lla-painted', '');
        var val = map[String(b.getAttribute('data-lla-swatch')).toLowerCase().replace(/\s/g, '')];
        if (val && /\.(jpe?g|png|svg|gif|webp)$/i.test(val)) {
          b.style.backgroundImage = 'url("' + base + val + '")';
        } else if (val) {
          b.style.backgroundColor = val;
        } else {
          /* Unknown colour name: a tiny photo of that variant instead. */
          var card = b.closest('.lla-pair-card');
          var p = card && pairProducts[card.getAttribute('data-lla-pid')];
          var v = p && (p.variants || []).filter(function (x) { return String(x.id) === b.getAttribute('data-lla-swatch-variant'); })[0];
          var img = v && variantImage(v, p);
          if (img) { b.style.backgroundImage = 'url("' + img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=60")'; b.classList.add('is-photo'); }
          else b.style.backgroundColor = '#E5E5E5';
        }
      });
    });
  }

  var pairProducts = {};
  function cardHtml(p) {
    pairProducts[p.id] = p;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    var img = v ? variantImage(v, p) : productImage(p);
    var cents = v ? variantCents(v) : priceCents(p);
    var safeTitle = esc(p.title);
    return '<div class="lla-pair-card" data-lla-pid="' + p.id + '" data-lla-cents="' + cents + '">' +
      '<a class="lla-pair-card__img" href="' + productUrl(p) + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="120" height="120">' : '') +
      '</a>' +
      '<a class="lla-pair-card__title" href="' + productUrl(p) + '">' + safeTitle + '</a>' +
      '<p class="lla-pair-card__price" data-lla-pair-price>' + formatMoney(cents) + '</p>' +
      (v ? swatchesHtml(p, v) : '') +
      (v ? '<button type="button" class="lla-pair-card__add" data-lla-add="' + v.id + '" data-lla-add-pid="' + p.id + '">Add</button>' : '') +
      '<p class="lla-pair-card__error" data-lla-pair-error role="alert" hidden></p>' +
      '</div>';
  }

  /* Picking a colour: swap photo, price, links and the variant Add sends.
     Any size picker already open on the card is reset, since the sizes on
     offer can differ by colour. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-lla-swatch-variant]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.lla-pair-card');
    var p = card && pairProducts[card.getAttribute('data-lla-pid')];
    if (!p) return;
    var v = (p.variants || []).filter(function (x) { return String(x.id) === sw.getAttribute('data-lla-swatch-variant'); })[0];
    if (!v) return;

    card.querySelectorAll('[data-lla-swatch-variant]').forEach(function (b) {
      var on = b === sw;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
    var img = card.querySelector('.lla-pair-card__img img');
    var src = variantImage(v, p);
    if (img && src) img.src = src;
    var href = productUrl(p) + (productUrl(p).indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id;
    card.querySelectorAll('.lla-pair-card__img, .lla-pair-card__title').forEach(function (a) { a.href = href; });
    card.setAttribute('data-lla-cents', variantCents(v));

    var btn = card.querySelector('[data-lla-add-pid]');
    var sel = card.querySelector('[data-lla-pair-size]');
    if (sel) sel.parentNode.removeChild(sel);
    var err = card.querySelector('[data-lla-pair-error]');
    if (err) err.hidden = true;
    if (btn) { btn.setAttribute('data-lla-add', v.id); btn.disabled = false; btn.textContent = 'Add'; }

    decoratePairPrices();
  });

  /* Never recommend: something already in the cart, either gift product, a
     zero-price (hidden) product, or anything sold out. */
  function isRecommendable(p, inCart) {
    if (!p || inCart[p.id]) return false;
    if (p.handle === GIFT_HANDLE || p.handle === GIFT_ALT_HANDLE) return false;
    if (p.handle === CASE_HANDLE || p.handle === CASE_ALT_HANDLE) return false;
    if (p.available === false) return false;
    if (priceCents(p) <= 0) return false;
    if (/\[hidden\]/i.test(p.title || '')) return false;
    return true;
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function recommendationsFor(productId) {
    if (!productId) return Promise.resolve([]);
    return getJSON('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (d) { return (d && d.products) || []; });
  }

  function productByHandle(handle) {
    return getJSON('/products/' + handle + '.js').catch(function () { return null; });
  }

  function renderPairs(cart) {
    var track = document.querySelector('[data-lla-pairs-track]');
    var wrap = document.querySelector('[data-lla-pairs]');
    if (!track || !wrap) return;

    var paid = cart.items.filter(function (it) { return !isGift(it); });
    var cartSeed = (paid[0] || cart.items[0] || {}).product_id;
    var viewed = recentlyViewedHandles();
    var browseSeedHandle = viewed[0] || '';

    /* Re-render only when the seed actually changes, so opening and closing the
       drawer does not refetch or reshuffle the row under the customer. */
    var seedKey = browseSeedHandle + '|' + (cartSeed || '');
    if (pairsSeed === seedKey && track.children.length) return;
    pairsSeed = seedKey;

    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });

    var collected = [];
    var seenIds = {};
    function absorb(list) {
      (list || []).forEach(function (p) {
        if (seenIds[p.id] || !isRecommendable(p, inCart)) return;
        seenIds[p.id] = true;
        collected.push(p);
      });
    }

    /* 1 — browsing, 2 — cart, 3/4 — fallback collection. Resolved in order and
       stopped as soon as there are enough cards to fill the row. */
    var browseStep = browseSeedHandle
      ? productByHandle(browseSeedHandle).then(function (p) {
          return p && p.id ? recommendationsFor(p.id) : [];
        })
      : Promise.resolve([]);

    browseStep
      .then(function (list) {
        absorb(list);
        if (collected.length >= 8 || !cartSeed) return null;
        return recommendationsFor(cartSeed);
      })
      .then(function (list) {
        absorb(list);
        if (collected.length >= 4 || !PAIRS_COLL) return null;
        return getJSON('/collections/' + PAIRS_COLL + '/products.json?limit=16')
          .then(function (d) { return (d && d.products) || []; });
      })
      .then(function (list) {
        absorb(list);
        var picks = collected.slice(0, 8);
        if (!picks.length) { wrap.hidden = true; pairsSeed = null; return; }
        track.innerHTML = picks.map(cardHtml).join('');
        paintSwatches(track);
        track.scrollLeft = 0;
        wrap.hidden = false;
        decoratePairPrices();
      })
      .catch(function () { pairsSeed = null; });
  }

  /* ---------- offer price on "You'll love this too" cards ----------------
     While the cart holds a qualifying band or bracelet, the offer banner
     (snippets/lla-band-offer.liquid) is in the drawer and names the offer
     collection and percent. A card then shows its price with that percent
     off — but ONLY if the product is really in that collection, i.e. the
     automatic discount will honour it at checkout. Earrings, necklaces and
     anything else outside it keep their normal price.

     Collection membership comes from sections/api-lla-offer-ids.liquid (a
     list of ids, a few hundred bytes per page), fetched once per session and
     kept in sessionStorage. Without the banner — nothing qualifying in the
     cart yet — every card shows its normal price. */
  var offerIds = {};
  function offerIdsFor(handle) {
    if (!handle) return Promise.resolve(null);
    if (offerIds[handle]) return offerIds[handle];
    var key = 'lla_offer_ids:' + handle;
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) { offerIds[handle] = Promise.resolve(JSON.parse(cached)); return offerIds[handle]; }
    } catch (e) {}
    function page(n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '?section_id=api-lla-offer-ids&page=' + n)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/data-pages="(\d+)"[^>]*>([\s\S]*?)<\/script>/);
          if (!m) return { pages: 0, ids: [] };
          var ids = [];
          try { ids = JSON.parse(m[2]); } catch (e) {}
          return { pages: parseInt(m[1], 10) || 1, ids: ids };
        });
    }
    offerIds[handle] = page(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= Math.min(first.pages, 10); n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        var set = {};
        [first].concat(more).forEach(function (r) { r.ids.forEach(function (id) { set[id] = 1; }); });
        try { sessionStorage.setItem(key, JSON.stringify(set)); } catch (e) {}
        return set;
      });
    }).catch(function () { delete offerIds[handle]; return null; });
    return offerIds[handle];
  }

  function decoratePairPrices() {
    var cards = document.querySelectorAll('[data-lla-pid]');
    if (!cards.length) return;
    var banner = document.querySelector('[data-lla-band-offer][data-lla-offer-collection]');
    var pct = banner ? parseFloat(banner.getAttribute('data-lla-offer-percent')) : 0;
    var handle = banner ? banner.getAttribute('data-lla-offer-collection') : '';

    function paint(set) {
      cards.forEach(function (card) {
        var el = card.querySelector('[data-lla-pair-price]');
        if (!el) return;
        var cents = parseInt(card.getAttribute('data-lla-cents'), 10) || 0;
        var qualifies = set && pct > 0 && set[card.getAttribute('data-lla-pid')];
        if (qualifies) {
          var offer = Math.round(cents * (100 - pct) / 100);
          el.innerHTML = '<del>' + formatMoney(cents) + '</del><ins>' + formatMoney(offer) + '</ins>';
          el.setAttribute('aria-label', 'Was ' + formatMoney(cents) + ', now ' + formatMoney(offer) + ' with ' + pct + '% off');
        } else {
          el.textContent = formatMoney(cents);
          el.removeAttribute('aria-label');
        }
      });
    }
    if (!banner) { paint(null); return; }
    offerIdsFor(handle).then(paint);
  }

  /* ---------- gift swap (alternate gift, or another variant of it) ----------
     Removes the current gift line and adds the target in one pass, then lets
     the theme redraw. The target variant id comes from the markup, which Liquid
     built from Theme settings — nothing is hard-coded here. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lla-gift-swap]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var target = parseInt(btn.getAttribute('data-target-variant'), 10) || 0;
    var targetHandle = btn.getAttribute('data-target-handle') || '';
    var lineKey = btn.getAttribute('data-line-key');
    if (!lineKey) return;
    if (!target && !targetHandle) return;

    /* Which slot is being swapped decides the property the new line carries,
       and that property is what the cart uses to render the line as a gift when
       the gift product itself is hidden from the Online Store channel. */
    var slot = btn.getAttribute('data-gift-slot') === 'case' ? 'case' : 'gift';
    var properties = slot === 'case'
      ? { _lla_case: targetHandle === CASE_ALT_HANDLE ? 'alt' : 'main' }
      : { _lla_gift: 'campaign' };

    btn.disabled = true;
    btn.classList.add('is-loading');

    /* Resolved from the handle when Liquid had no variant id to write, which is
       the normal case for a gift product kept off the Online Store channel. */
    variantForHandle(targetHandle, target).then(function (variantId) {
      if (!variantId) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        return;
      }
      inFlight = true;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
          });
        })
        .then(function () { inFlight = false; btn.disabled = false; refreshTheme(); })
        .catch(function () { inFlight = false; btn.disabled = false; btn.classList.remove('is-loading'); });
    });
  });

  /* ---------- "You'll love this too": add in the customer's watch size ----
     A card's Add button used to send the product's first available variant,
     which for an Apple Watch band is simply its smallest size. Now, for any
     product with an Apple Watch Size option, the size is taken from the band
     already in the cart and the exact equivalent variant is added — keeping
     the colour/finish shown on the card.

     Size labels are written differently from product to product ("42mm
     (Series 3)" / "42mm (series 3)", "49mm" / "49mm (Ultra)"), so each is
     reduced to a key — millimetres plus any Series number — and only an EXACT
     key match is added automatically:
       42mm (Series 3) -> 42s3    42mm (Series 10) -> 42s10 (never merged)
       46mm / 46mm (Series 10) -> 46      49mm / 49mm (Ultra …) -> 49
     No band in the cart, bands of different sizes, or no exact match: the card
     shows a size picker instead and nothing is added until a size is chosen.
     A size is never guessed. Products without a watch size (bracelets) add
     exactly as before. */
  var SIZE_OPTION_NAMES = ['apple watch size', 'watch size'];

  function sizeKey(label) {
    var s = String(label || '').toLowerCase().trim();
    var mm = s.split('mm')[0].replace(/\s+/g, '');
    var q = '';
    if (s.indexOf('ultra') === -1 && s.indexOf('series') !== -1) {
      q = 's' + s.split('series').pop().split(')')[0].trim();
    }
    if (mm === '46' && q === 's10') q = '';
    return mm + q;
  }
  function optionNames(p) {
    return (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).toLowerCase().trim(); });
  }
  function variantOptions(v) {
    if (v.options && v.options.length) return v.options;
    return [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
  }
  function sizeIndex(p) {
    var names = optionNames(p);
    for (var i = 0; i < names.length; i++) if (SIZE_OPTION_NAMES.indexOf(names[i]) !== -1) return i;
    return -1;
  }
  /* The one watch size in the cart, or '' when there is none or they differ. */
  function cartSize(cart) {
    var found = null, mixed = false;
    cart.items.forEach(function (it) {
      if (isGift(it)) return;
      (it.options_with_values || []).forEach(function (o) {
        if (SIZE_OPTION_NAMES.indexOf(String(o.name).toLowerCase().trim()) === -1) return;
        if (found === null) found = o.value; else if (sizeKey(found) !== sizeKey(o.value)) mixed = true;
      });
    });
    return mixed || found === null ? '' : found;
  }
  /* Everything about the look except the size, e.g. "Gold|" or "Gold|Cross|". */
  function lookOf(v, idx) {
    return variantOptions(v).filter(function (_, i) { return i !== idx; }).join('|');
  }

  function postAdd(id) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }

  function finishAdd(btn, card, res, label) {
    var err = card && card.querySelector('[data-lla-pair-error]');
    if (!res.ok) {
      btn.disabled = false;
      btn.textContent = 'Add';
      if (err) { err.textContent = (res.data && res.data.description) || 'Sorry, this could not be added.'; err.hidden = false; }
      return;
    }
    btn.textContent = label ? 'Added · ' + label : 'Added';
    refreshTheme();
  }

  function showSizePicker(btn, card, p, idx, lead) {
    if (card.querySelector('[data-lla-pair-size]')) return;
    var look = lookOf(lead, idx);
    var opts = (p.variants || []).filter(function (v) { return v.available && lookOf(v, idx) === look; });
    if (!opts.length) opts = (p.variants || []).filter(function (v) { return v.available; });
    var sel = document.createElement('select');
    sel.className = 'lla-pair-card__size';
    sel.setAttribute('data-lla-pair-size', '');
    sel.setAttribute('aria-label', 'Choose your Apple Watch size');
    sel.innerHTML = '<option value="">Select size</option>' + opts.map(function (v) {
      var o = document.createElement('option');
      o.value = v.id; o.textContent = variantOptions(v)[idx];
      return o.outerHTML;
    }).join('');
    btn.parentNode.insertBefore(sel, btn);
    btn.setAttribute('data-lla-add', '');
    btn.disabled = false;
    btn.textContent = 'Add';
    sel.focus();
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-lla-pair-size]');
    if (!sel) return;
    var card = sel.closest('.lla-pair-card');
    var btn = card && card.querySelector('[data-lla-add-pid]');
    if (btn) btn.setAttribute('data-lla-add', sel.value || '');
    var err = card && card.querySelector('[data-lla-pair-error]');
    if (err) err.hidden = true;
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lla-add-pid]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var card = btn.closest('.lla-pair-card');
    var err = card && card.querySelector('[data-lla-pair-error]');
    var sel = card && card.querySelector('[data-lla-pair-size]');
    var p = pairProducts[btn.getAttribute('data-lla-add-pid')];

    /* A size already picked from the card's own picker. */
    if (sel) {
      var chosen = parseInt(sel.value, 10);
      if (!chosen) {
        if (err) { err.textContent = 'Please choose your Apple Watch size.'; err.hidden = false; }
        sel.focus();
        return;
      }
      btn.disabled = true; btn.textContent = 'Adding…';
      postAdd(chosen).then(function (res) { finishAdd(btn, card, res, sel.options[sel.selectedIndex].text); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
      return;
    }

    var idx = p ? sizeIndex(p) : -1;
    var defaultId = parseInt(btn.getAttribute('data-lla-add'), 10);

    /* No watch size on this product (bracelets etc.): add as before. */
    if (idx === -1) {
      if (!defaultId) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      postAdd(defaultId).then(function (res) { finishAdd(btn, card, res); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
      return;
    }

    btn.disabled = true; btn.textContent = 'Adding…';
    getCart().then(function (cart) {
      var lead = (p.variants || []).filter(function (v) { return v.id === defaultId; })[0] ||
                 (p.variants || []).filter(function (v) { return v.available; })[0];
      var size = cartSize(cart);
      var match = null;
      if (size && lead) {
        var key = sizeKey(size), look = lookOf(lead, idx);
        var sameSize = (p.variants || []).filter(function (v) {
          return v.available && sizeKey(variantOptions(v)[idx]) === key;
        });
        /* Only in the colour/finish shown on the card. If that look is sold
           out in their size, the picker appears rather than a different
           colour being swapped in. */
        match = sameSize.filter(function (v) { return lookOf(v, idx) === look; })[0] || null;
      }
      if (match) {
        postAdd(match.id).then(function (res) { finishAdd(btn, card, res, variantOptions(match)[idx]); })
          .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
      } else {
        showSizePicker(btn, card, p, idx, lead || {});
      }
    }).catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
  });

  /* ---------- triggers (event-driven only — no per-page fetch) ---------- */
  function ping() { clearTimeout(debounce); debounce = setTimeout(reconcile, 180); }
  ['theme:cart:added', 'theme:cart:add', 'theme:cart:update', 'theme:cart:open', 'theme:cart:loaded', 'cart:added', 'cart:updated', 'cart:update', 'cart:refresh', 'cart:loaded', 'cart:change', 'cart:open', 'ajaxProduct:added'].forEach(function (ev) {
    document.addEventListener(ev, ping);
    window.addEventListener(ev, ping);
  });
  // Also fire when the user opens the cart drawer (covers themes that don't emit cart:open)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-drawer-toggle],[href="#cart-drawer"],[data-cart-open]')) setTimeout(ping, 80);
  });
  // Re-sync when the drawer (re)renders. Observe the STABLE #cart-drawer wrapper —
  // the drawer body sits in an inert <template> until the theme clones it into the DOM.
  var mo = null;
  function watch() {
    if (mo) return;
    var root = document.getElementById('cart-drawer') || document.body;
    mo = new MutationObserver(function () { if (syncing) return; clearTimeout(moTimer); moTimer = setTimeout(function () { syncUI(); }, 250); });
    mo.observe(root, { childList: true, subtree: true });
  }
  function boot() { watch(); convertStaticFigures(); convertWorth(); reconcile(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
